/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import '~styles/modules/returnAnchor.scss';


const ReturnAnchor = ({ data }) => {

  //const image = "style='background-image: url("+photo+"')"

  return (
  	<p className="paragraph content">
  		<a className="top-anchors" href="#top">Return to top</a>
  	</p>

    	
  );

};




export default ReturnAnchor;
